import { isClientSide } from './ssrUtils';

export function getPageName(): string {
  let pageName: string = '';
  if (typeof window === 'undefined') return '';
  if (window.location.pathname === '/search') {
    pageName = 'Search';
  } else if (window.page_name) {
    pageName = window.page_name;
  }
  return pageName;
}

export function isHomepage(): boolean {
  return isClientSide && window.location.pathname === '/';
}
